import { render, staticRenderFns } from "./MemberHome.vue?vue&type=template&id=f304d16a&scoped=true"
import script from "./MemberHome.vue?vue&type=script&lang=js"
export * from "./MemberHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f304d16a",
  null
  
)

export default component.exports